<template>
	<div id="orthoStageDiv" class="ortho-mode-item">
		<div id="orthoStageHint" class="ortho-mode-item">
			<span>{{ mode.stageName }}</span>
			<!-- <span id="orthoStageStar">&nbsp;*</span> -->
		</div>

		<div id="orthoPlanOriginalDiv" class="orto-no-intraoral toggle-div" v-on:click.stop="showOriginalClick()">
			<input id="orthoPlanOriginalButton" type="checkbox" class="toggle-ortho-plan-button" />
			<div id="orthoPlanOriginalLabel" class="toggle-title">SHOW ORIGINAL</div>
		</div>

		<button id="colorOriginalButton" v-show="mode.showOriginal" type="button" class="orto-no-intraoral original-button"
			onclick="openColorPicker('original_teeth_color');">
			TEETH COLOR
		</button>

		<div id="orthoPlanCollisionsDiv" class="toggle-div orto-no-intraoral"
			v-on:click.stop="showCollisionsClick($event)">
			<input id="orthoPlanCollisionsButton" type="checkbox" class="toggle-ortho-plan-button" />
			<div id="orthoPlanCollisionsLabel" class="toggle-title">SHOW COLLISIONS</div>
		</div>

		<div id="orthoPlanAnchorageLossDiv" class="toggle-div orto-no-intraoral"
			v-on:click.stop="showAnchorageLossClick($event)">
			<input id="orthoPlanAnchorageLossButton" type="checkbox" class="toggle-ortho-plan-button" />
			<div id="orthoPlanAnchorageLossLabel" class="toggle-title">SHOW ANCHORAGE LOSS</div>
		</div>

		<div id="orthoPlanExtractDiv" class="toggle-div orto-no-intraoral" v-bind:style="{ display: editContext.display }"
			v-on:click.stop="switchExtract()">
			<input id="orthoPlanExtractButton" type="checkbox" class="toggle-ortho-plan-button" />
			<div id="orthoPlanExtractLabel" class="toggle-title">EXTRACT</div>
		</div>

		<!-- <button id="opacityOriginalButton" type="button"
			class="ortho-mode-item original-button">
			TEETH OPACITY
		</button> -->
	</div>
</template>

<script>
import { OrthoPlanMode, toggleShowOriginal, toggleShowCollisions, toggleAnchorageLoss, toggleExtract } from "./OrthoPlanMode";

export default {
	name: "OrthoPlanControls",
	props: ["mode", "editContext"],
	components: {},
	methods: {
		showOriginalClick: function () {
			toggleShowOriginal(!OrthoPlanMode.showOriginal);
		},
		showCollisionsClick: function () {
			toggleShowCollisions(!OrthoPlanMode.showCollisions);
		},
		showAnchorageLossClick: function () {
			toggleAnchorageLoss(!OrthoPlanMode.showAnchorageLoss);
		},
		switchExtract: function () {
			toggleExtract(this.editContext.tooth);
		}
	},
	mounted: function () {
		// setTimeout(function () {
		canecode_switch(".toggle-ortho-plan-button");
		switchToggle('orthoPlanOriginalDiv', false);
		switchToggle('orthoPlanCollisionsDiv', false);
		switchToggle('orthoPlanAnchorageLossDiv', false);
		switchToggle("orthoPlanExtractDiv", false);
		console.log("OrthoPlanControls mounted", vueApp.hasClosedBones);

		if (!vueApp.hasClosedBones) {
			document.getElementById("orthoPlanAnchorageLossDiv").style.display = "none"
		}

		// }, 999);
	}
};
</script>

<style scoped>
/* @import "opacity.css";
*/

/* .toggle-div {
	top: 50px;
	width: 110px;
} */

.toggle-div {
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	/*#797979;*/
}

#orthoStageDiv {
	left: calc(50% - 240px);
	top: 50px;
	width: 440px;
	color: white;
}

#orthoStageHint {
	width: 100px;
	left: calc(50% - 41px);
	text-align: center;
	/* font-weight: bold; */
	/* background-color: transparent; */
}

#orthoPlanOriginalDiv {
	width: 100px;
	left: calc(50% - 180px);
	top: 30px;
}

#orthoPlanOriginalLabel {
	margin-left: -20px;
}

#colorOriginalButton {
	left: calc(50% - 195px);
}

#orthoPlanCollisionsDiv {
	width: 120px;
	left: calc(50% - 30px);
	top: 30px;
}

#orthoPlanCollisionsLabel {
	margin-left: -40px;
}

#orthoPlanAnchorageLossDiv {
	width: 120px;
	left: calc(50% + 120px);
	top: 30px;
}

#orthoPlanAnchorageLossLabel {
	margin-left: -50px;
}

#orthoPlanExtractDiv {
	left: calc(50% - 30px);
	top: 110px;
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	/*#797979;*/
}

#orthoPlanExtractLabel {
	margin-left: 2px;
}

.toggle-title {
	margin-left: -15px;
}

.original-button {
	position: absolute;
	width: 110px;
	height: 40px;
	border: 0;
	cursor: pointer;
	font-size: 12px;
	background-color: #4687fc;
	z-index: 9;
	top: 110px;
	color: white;
}

#opacityOriginalButton {
	left: calc(50% + 25px);
}
</style>